import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8def95401ce4598/app/[locale]/faq/FAQPageClient.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustBadges"] */ "/tmp/8def95401ce4598/components/sections/TrustBadges.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/app/[locale]/faq/FAQPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
